// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bwwo","label":"styles_label__3y5xN"};